"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./NotFound.css");
// import sound from "../../public/vine-boom-holy-moly.mp3";
const NotFound = () => {
    // const audioElementRef = useRef<HTMLAudioElement>(null);
    // const playAudio = () => {
    //   if (audioElementRef.current) {
    //     audioElementRef.current.play().catch(error => {
    //       console.error("Error playing audio:", error);
    //     });
    //   }
    // };
    return (react_1.default.createElement("div", { className: "NotFound" },
        react_1.default.createElement("div", { className: "u-hideOverflow NotFound-container" },
            react_1.default.createElement("div", { className: "u-flexColumn NotFound-textContainer" },
                react_1.default.createElement("h1", null, "Page Not Found"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "u-flex u-flex-justifyCenter u-flex-alignCenter" },
                        react_1.default.createElement("center", null,
                            react_1.default.createElement("img", { src: "https://media.tenor.com/TmvqZuZdfqQAAAAM/holy-moly-holy.gif", alt: "" }))),
                    react_1.default.createElement("br", null),
                    "Unfortunately, this page (",
                    react_1.default.createElement("strong", null, window.location.pathname),
                    ") doesn't exist.",
                    react_1.default.createElement("br", null),
                    "What you see in the bar is what we've got!")))));
};
exports.default = NotFound;
